export { default } from './Informer.tsx'
